import { Order } from "@/types"
import { getDatetimeSortValue } from "@/utils"

import { OrdersTableHeader } from "./partials/OrdersTable"

const statePriorities = {
  draft: 0,
  unpaid: 0,
  waiting: 1,
  pending: 2,
  assigned: 3,
  published: 4,
  started: 5,
  finished: 6,
  failed: 7,
  canceled: 8,
  expired: 9,
}

export function sortOrderListColumn(column: OrdersTableHeader, isSortedDesc: boolean) {
  const returnValue = isSortedDesc ? -1 : 1

  switch (column) {
    case "ordinal":
      break

    case "provider":
      return () => (a: Order, b: Order) => {
        const valueA = a.provider !== "deligoo" ? a.provider : ""
        const valueB = b.provider !== "deligoo" ? b.provider : ""

        return valueA.localeCompare(valueB, "pl") * returnValue
      }

    case "order_id":
      return () => (a: Order, b: Order) => {
        const value = getDatetimeSortValue(a.created_at, b.created_at)

        return value * returnValue
      }

    case "driver":
      return () => (a: Order, b: Order) => {
        const valueA = a.driver?.name || ""
        const valueB = b.driver?.name || ""

        return valueA.localeCompare(valueB, "pl") * returnValue
      }

    case "pickup":
      return () => (a: Order, b: Order) => {
        const value = getDatetimeSortValue(a.pickup?.estimated_time, b.pickup?.estimated_time)

        return value * returnValue
      }

    case "delivery":
      return () => (a: Order, b: Order) => {
        const value = getDatetimeSortValue(a.delivery?.estimated_time, b.delivery?.estimated_time)

        return value * returnValue
      }

    case "params":
      return () => (a: Order, b: Order) => {
        const value = getDatetimeSortValue(a.perform_at, b.perform_at)

        return value * returnValue
      }

    case "state":
      return () => (a: Order, b: Order) => {
        const value = statePriorities[a.state] - statePriorities[b.state]

        return value * returnValue
      }
  }
}
